var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 102,
    viewBox: "0 0 273 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.01465,
    width: 272,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 61.6464H118.756V46.0375H115.2V61.6464ZM116.971 43.9906C118.085 43.9906 118.956 43.107 118.956 42.0027C118.956 40.8835 118.085 40 116.971 40C115.871 40 115 40.8835 115 42.0027C115 43.1071 115.871 43.9906 116.971 43.9906ZM130.595 40.0441C124.583 40.0441 120.813 44.2703 120.813 51.0294C120.813 57.7885 124.582 62 130.595 62C136.593 62 140.363 57.7885 140.363 51.0294C140.363 44.2703 136.593 40.0441 130.595 40.0441ZM130.595 43.2837C134.265 43.2837 136.607 46.2877 136.607 51.0293C136.607 55.7562 134.265 58.7602 130.595 58.7602C126.911 58.7602 124.583 55.7562 124.583 51.0293C124.583 46.2878 126.911 43.2837 130.595 43.2837ZM141.863 55.6679C142.02 59.585 145.133 61.9999 149.874 61.9999C154.858 61.9999 158 59.4671 158 55.4323C158 52.2664 156.229 50.4846 152.045 49.4981L149.674 48.9385C147.147 48.32 146.104 47.4954 146.104 46.0818C146.104 44.3147 147.675 43.1367 150.003 43.1367C152.359 43.1367 153.973 44.3294 154.144 46.3174H157.657C157.572 42.5771 154.573 40.0442 150.032 40.0442C145.547 40.0442 142.363 42.5917 142.363 46.3615C142.363 49.3949 144.162 51.2798 147.961 52.1781L150.631 52.8261C153.23 53.4593 154.287 54.3428 154.287 55.8742C154.287 57.6413 152.559 58.9077 150.074 58.9077C147.561 58.9077 145.662 57.6266 145.433 55.6681L141.863 55.6679Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/IOS.905446a5b01fa4eb43e890a4abd3c844.svg";
export { ForwardRef as ReactComponent };